export default __webpack_public_path__ + "static/media/arrow-right-small.168b04e4.svg";